// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27zuU","buttons":"styles_buttons__10CLZ"};